export const headerStyles = {

  container: {
    position: 'relative' as const,
    zIndex: 1,
    minHeight: '210px',
    padding: 'var(--mantine-spacing-md) 0',
    backgroundColor: 'var(--mantine-color-brand-9)',
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    marginRight: 'var(--mantine-spacing-md)',
  },
  contactItem: {
    alignItems: 'flex-start',
    border: '2px solid var(--mantine-color-white)',
    outline: '5px solid var(--mantine-color-white)',
    outlineOffset: '2px',
    borderRadius: 'var(--mantine-radius-md)',
    padding: 'var(--mantine-spacing-md)',
    marginTop: 'var(--mantine-spacing-md)',
    marginBottom: 'var(--mantine-spacing-md)',
    marginLeft: 'var(--mantine-spacing-md)',
    marginRight: 'var(--mantine-spacing-md)',
  },
  headerInfoText: {
    color: 'var(--mantine-color-white)',
  },
}
